import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  activate(event) {
    // Remove active class from all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove("active")
    })

    // Add active class to clicked tab
    event.currentTarget.classList.add("active")
  }
}